import cx from 'classnames'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import {
  SubmissionSection,
  SubmissionSectionHeader,
} from '../SubmissionSection'
import { observer } from 'mobx-react'
import * as React from 'react'
import CouponSelectionViewModel from '../../../../CouponSelectionViewModel'
import styles from './CouponSelection.sass'

interface CouponSelectionProps {
  vm: CouponSelectionViewModel
  compact?: boolean
}

/**
 * The CouponSelection
 */
export default observer(function CouponSelection({
  vm,
  compact,
}: CouponSelectionProps) {
  return (
    <SubmissionSection compact={compact}>
      {vm.selected ? (
        <>
          <SubmissionSectionHeader label="Applied Coupon" compact={compact}>
            <Button
              size={compact ? 'normal' : 'baseline'}
              type="text"
              onClick={vm.show}
              disabled={vm.disabled || vm.tasks.pending}
            >
              Change
            </Button>
          </SubmissionSectionHeader>
          <SelectedCoupon vm={vm} compact={compact} />
        </>
      ) : (
        <div className={cx(styles.addCoupon, compact && styles.compact)}>
          <Button
            block
            type="text"
            onClick={vm.show}
            disabled={vm.disabled || vm.tasks.pending}
            data-test="draft-editor-add-coupon-button"
          >
            I have a coupon
          </Button>
        </div>
      )}
    </SubmissionSection>
  )
})

interface SelectedCouponProps {
  vm: CouponSelectionViewModel
  compact?: boolean
}

const SelectedCoupon = observer(function SelectedCoupon({
  vm,
  compact,
}: SelectedCouponProps) {
  const coupon = vm.selected
  if (!coupon) {
    return null
  }

  return (
    <div className={cx(styles.selectedCoupon, compact && styles.compact)}>
      <div className={styles.selectedCouponInfo}>
        <div
          className={styles.selectedCouponTitle}
          data-test="draft-editor-selected-coupon-code"
        >
          {coupon.code}
        </div>
        {coupon.description && (
          <div className={styles.selectedCouponDescription}>
            {coupon.description}
          </div>
        )}
      </div>
      <div className={styles.selectedCouponActions}>
        <IconButton
          variant="ghost"
          onClick={vm.remove}
          disabled={vm.disabled || vm.tasks.pending}
          loading={vm.remove.pending}
          data-test="draft-editor-remove-selected-coupon"
        >
          <Icon name="close" />
        </IconButton>
      </div>
    </div>
  )
})
